export default "/images/denastia.png?7cf48b7168aa7242719dfbbed728d200";